import React from 'react';
import { useOnClickOutside } from 'components/common/hooks'

const DropDown = React.forwardRef((props, ref) => {
    const { toggleable, className, header, noArrow, frozenItems, children, dropdownItemsWrapperStyle } = props
    const [opened, setOpen] = React.useState(false)
    const dropdownRef = React.useRef(null)
    React.useImperativeHandle(ref, () => ({
        handleClick: () => {
            handleClick();
        }
    }));
    function handleClick() {
        toggleable && setOpen(!opened)
    }

    function close() {
        setOpen(false)
    }

    useOnClickOutside(dropdownRef, () => {
        opened && close()
    });

    return (
        <div ref={dropdownRef} className={`${opened ? "dropdown open" : "dropdown"} ${className ? className : ''}`}>
            <div className="dropdown__toggle" onClick={() => handleClick()}>
                {header}
                {!noArrow &&
                    <img className="dropdown__toggle__arrow" src={"src/assets/icons/" + (opened ? "arrow-up.svg" : "arrow-down.svg")} />
                }
            </div>
            {toggleable &&
                <div onClick={() => frozenItems ? null : close()} className="dropdown__items" style={dropdownItemsWrapperStyle}>
                    {children}
                </div>
            }
        </div>
    )
})


export default DropDown



// WEBPACK FOOTER //
// ./src/components/common/dropdowncomponents/dropdown.jsx